import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../../utils/enum";

export const useGetCustomerExcel = (successCallback?: () => void, errorCallback?: (error: any) => void) => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation({
        mutationFn: async () => {
            const category = 1;
            const requestUrl = `${enum_api_uri.get_customer_excel}?customer_category=${category}`;
            const response = await axios.get(requestUrl, {
                headers: { Authorization: `Bearer ${accessToken}` },
                responseType: "blob",
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;

            link.setAttribute("download", "고객정보.xlsx");

            document.body.appendChild(link);
            link.click();
            link.parentNode?.removeChild(link);
        },
        onSuccess: () => {
            successCallback?.();
        },
        onError: error => {
            errorCallback?.(error);
        },
    });
};
